import { z } from 'zod';

// Schema for individual transfer item
export const stockTransferItemSchema = z.object({
  id: z.number().optional(),
  item_id: z.number().min(1, 'Item is required'),
  item: z.object({
    id: z.number(),
    name: z.string(),
    sku: z.string().optional().nullable(),
    unit: z.object({
      id: z.number(),
      name: z.string(),
      symbol: z.string(),
    }).optional(),
  }).optional(),
  quantity: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    return isNaN(num) ? 0 : num;
  }).refine((val) => val > 0, 'Quantity must be greater than 0'),
  rate: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    return isNaN(num) ? 0 : num;
  }).refine((val) => val >= 0, 'Rate must be non-negative'),
  unit_id: z.number().min(1, 'Unit is required'),
  notes: z.string().optional(),
  current_stock: z.number().optional(), // For display purposes
});

// Main form schema
export const stockTransferFormSchema = z.object({
  source_godown_id: z.number().min(1, 'Source godown is required'),
  destination_godown_id: z.number().min(1, 'Destination godown is required'),
  transaction_date: z.string().min(1, 'Date is required'),
  reference_number: z.string().optional(),
  notes: z.string().optional(),
  items: z.array(stockTransferItemSchema).min(1, 'At least one item is required'),
}).refine((data) => data.source_godown_id !== data.destination_godown_id, {
  message: 'Source and destination godowns must be different',
  path: ['destination_godown_id'],
});

export type StockTransferFormValues = z.infer<typeof stockTransferFormSchema>;